/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import {Helmet} from "react-helmet"
import { useStaticQuery, graphql, withPrefix } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n";

function SEO({ description, meta, title }) {
  const { site, eventName  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
        eventName : eventCsv(key: {eq: "name.full"}) {
          ...localizedContent
        }
      }
    `
  )

  const { t,currentLocaleObj,originalPath,localeKey } = useLocalization();

  const metaDescription = description || site.siteMetadata.description;

  var metaTags = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `og:title`,
      content:  `${(originalPath === '/' || originalPath === '') ? eventName[localeKey] : `${title}  | ${eventName[localeKey]}`}`,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      property: `og:url`,
      content: `${site.siteMetadata.siteUrl}/2021/${currentLocaleObj.prefix}${originalPath}`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata.author,
    },
    {
      name: `twitter:title`,
      content: `${(originalPath === '/' || originalPath === '') ? eventName[localeKey] : `${title} | ${eventName[localeKey]}`}`,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    {
      property : `og:site_name`,
      content: t('event.name.full')
    }
  ].concat(meta);

  return(
    <Helmet>
      <meta charSet="utf-8"/>
      <title>{`${(originalPath === '/' || originalPath === '') ? eventName[localeKey] : `${title} | ${eventName[localeKey]}`}`}</title>
      {metaTags.map((item,index) => {
        return React.createElement( 'meta', {key:`meta_${index}` ,...item} );
      })}
      <meta property="og:image" content={`${site.siteMetadata.siteUrl}${currentLocaleObj.code === "ja" ? withPrefix('ogp_ja.jpg') : withPrefix('ogp_global.jpg')}`}/>
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
